
import { Button, Input, Space, Select, Checkbox } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import { flushSync } from 'react-dom';

const getColumnSearchProps = (dataIndex, dataFilter, setDataFilter, getData, type = "text") => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input

                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0] ?? dataFilter}
                onChange={(e) => {
                    const nextValue = e.target.value
                    setSelectedKeys(nextValue ? [nextValue] : [])
                    setDataFilter(nextValue)
                }}
                onPressEnter={() => {
                    flushSync(() => setDataFilter(selectedKeys[0] ?? ''))
                    getData()
                }}
                style={{
                    marginBottom: 8,
                    display: 'block',
                }}
                type={type}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => {
                        flushSync(() => setDataFilter(selectedKeys[0] ?? ''))
                        getData()
                    }}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => {
                        setSelectedKeys([])
                        flushSync(() => setDataFilter(''))
                        getData()
                    }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),
    onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

});

export const getDropdownSearchProps = (dataIndex, options, changeValues, placeHolder, getData) => ({
    filterDropdown: ({ close, selectedKeys, setSelectedKeys }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Select
                style={{
                    width: '100%',
                    marginBottom: 8,
                    display: 'block',
                }}
                value={selectedKeys?.[0] ?? undefined}
                placeholder={placeHolder}
                onSelect={(val, option) => {
                    setSelectedKeys([val])
                    changeValues(dataIndex, option)
                }}
                options={options}
                showSearch={true}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                allowClear
                onClear={() => {
                    setSelectedKeys([])
                    changeValues(dataIndex, { value: 0, label: '' })
                }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => {
                        const selectedOption = options.find(
                            (option) => `${option?.value}` === `${selectedKeys?.[0] ?? ''}`,
                        )
                        flushSync(() =>
                            changeValues(dataIndex, selectedOption ?? { value: 0, label: '' }),
                        )
                        getData()
                    }}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => {
                        setSelectedKeys([])
                        flushSync(() => changeValues(dataIndex, { value: 0, label: '' }))
                        getData()
                    }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),

});

export const getCheckboxFilterProps = (dataIndex, options, selectedKeys, changeValues, getData) => ({
    filterDropdown: ({ close, selectedKeys: internalSelectedKeys, setSelectedKeys }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Checkbox.Group
                options={options}
                value={internalSelectedKeys?.length ? internalSelectedKeys : selectedKeys}
                onChange={(values) => {
                    setSelectedKeys(values)
                    changeValues(dataIndex, values)
                }}
                style={{ display: 'block', marginLeft: 0 }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => {
                        flushSync(() => changeValues(dataIndex, internalSelectedKeys ?? []))
                        getData();
                    }}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => {
                        setSelectedKeys([])
                        flushSync(() => changeValues(dataIndex, []))
                        getData()
                    }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),
});

export default getColumnSearchProps;
